import { Card, Divider, Tag, Tooltip } from '@blueprintjs/core';
import { sms } from '@axo/shared/data-access/types';
import { CreatedAtTag, OrttoSMSIcon } from '../CommunicationItem';
import cardClasses from '../CommunicationItem/Card.module.css';
import { useCustomer } from '@axo/shared/data-access/hooks';
import { formatDatetime } from '../../../utils/formatDate.ts';

interface IOrttoSMSCard {
  sms: sms.OrttoSMS;
  body?: sms.OrttoSMSBody;
}

const StatusTag = ({
  status,
  timestamp,
}: {
  status: sms.OrttoSMSStatus;
  timestamp: string;
}) => {
  const getIntent = () => {
    switch (status) {
      case sms.OrttoSMSStatus.Sent:
        return 'warning';
      case sms.OrttoSMSStatus.Delivered:
        return 'primary';
      case sms.OrttoSMSStatus.Clicked:
        return 'success';
      case sms.OrttoSMSStatus.Bounced:
        return 'danger';
      default:
        return 'none';
    }
  };

  return (
    <Tooltip position={'bottom'} content={formatDatetime(timestamp)}>
      <Tag intent={getIntent()} minimal>
        {status}
      </Tag>
    </Tooltip>
  );
};

export function OrttoSMSCard({ sms, body }: IOrttoSMSCard) {
  const customer = useCustomer(sms.CustomerID);
  return (
    <Card className={cardClasses.card}>
      <div className={cardClasses.topBar}>
        <OrttoSMSIcon />
        <Tag round minimal>
          Ortto
        </Tag>
        <CreatedAtTag label="Sent at:" createdAt={sms.CreatedAt} />
        <div className={cardClasses.fill} />
      </div>
      <Divider />
      <div className={cardClasses.body}>
        <div className={cardClasses.formRow}>
          <span className={cardClasses.label}>Campaign: </span>
          <span className={cardClasses.fill}>{sms.CampaignName}</span>
        </div>
        <div className={cardClasses.formRow}>
          <span className={cardClasses.label}>Status:</span>
          <span className={cardClasses.tags}>
            {sms.OrttoSMSStatusUpdates.map((statusUpdate) => (
              <StatusTag
                key={statusUpdate.ID}
                status={statusUpdate.Status}
                timestamp={statusUpdate.WebhookReceivedAt}
              />
            ))}
          </span>
        </div>
        <div className={cardClasses.formRow}>
          <span className={cardClasses.label}>To:</span>
          <span>{customer.data?.MobilePhoneNumber ?? ''}</span>
        </div>
        <Divider />
        <div className={cardClasses.body}>
          <div>{body ? body.Body : ''}</div>
        </div>
      </div>
    </Card>
  );
}
